import data from './data';

export default {
  projects: [
    {
      id: 'gfq76dzo12',
      name: 'Lorem sa dipsum',
      created: Date.now(),
      author: 'some_id',
      preview: require('./assets/editor/preview.png'),
      backgroundImage: require('./assets/bg-map.jpg'),
      scenes: [ ...data ],
      sets: [
        {
          id: 'set-name',
          name: 'Default Set A',
          markers: [
            {
              name: 'groups',
              image: require('./assets/marks/groups.svg'),
            },
            {
              name: 'news',
              image: require('./assets/marks/news.svg'),
            },
            {
              name: 'publication',
              image: require('./assets/marks/publication.svg'),
            },
            {
              name: 'theme',
              image: require('./assets/marks/theme.svg'),
            },
            {
              name: 'video',
              image: require('./assets/marks/video.svg'),
            },
            {
              name: 'use_case',
              image: require('./assets/marks/use_case.svg'),
            },
          ]
        }
      ],
      media: [
        {
          id: 'some_name_of_media',
          name: 'some name of media',
          path: 'url/blabla/some_file.pdf',
          type: 'audio', // audio / pdf / video / link
          author: 'maksim',
          description: 'somebody once told me the world is gonna roll me',
        },
        {
          id: 'some_name_of_media1',
          name: 'some name of media1',
          path: 'url/blabla/some_file.pdf',
          type: 'audio', // audio / pdf / video / link
          author: 'maksim',
          description: 'somebody once told me the world is gonna roll me',
        },
        {
          id: 'some_name_of_media2',
          name: 'some name of media2',
          path: 'url/blabla/some_file.pdf',
          type: 'pdf', // audio / pdf / video / link
          author: 'maksim',
          description: 'somebody once told me the world is gonna roll me',
        },
        {
          id: 'some_name_of_media3',
          name: 'some name of media3',
          path: 'url/blabla/some_file.pdf',
          type: 'video', // audio / pdf / video / link
          author: 'maksim',
          description: 'somebody once told me the world is gonna roll me',
        },
        {
          id: 'some_name_of_media4',
          name: 'some name of media4',
          path: 'url/blabla/some_file.pdf',
          type: 'link', // audio / pdf / video / link
          author: 'maksim',
          description: 'somebody once told me the world is gonna roll me',
        },
      ],
    },
  ],
};
